module.exports = __webpack_public_path__ + "img/tipwise-logo-card.5be80f0b.jpg";